import type { ReactNode } from "react";

/**
 * La pastille de statut.
 *
 * Chaque ton prend le TRIPLET de sa rampe : le fond en `-subtle`, le texte en
 * `-strong`. Jamais le `-default` pour le texte : c'est la valeur du trait, et sur
 * blanc elle passe sous le seuil de contraste AA.
 */

export type Tone = "neutral" | "info" | "success" | "warning" | "error" | "brand";

const TONE: Record<Tone, string> = {
	neutral: "bg-mg-hover text-mg-body border-mg-border",
	info: "bg-mg-info-subtle text-mg-info-fg border-transparent",
	success: "bg-mg-success-subtle text-mg-success-fg border-transparent",
	warning: "bg-mg-warning-subtle text-mg-warning-fg border-transparent",
	error: "bg-mg-error-subtle text-mg-error-fg border-transparent",
	brand: "bg-mg-selected text-mg-action border-transparent",
};

export function Badge({ tone = "neutral", children }: { tone?: Tone; children: ReactNode }) {
	return (
		<span
			className={`t-caption-strong inline-flex shrink-0 items-center whitespace-nowrap rounded-full border px-2.5 py-0.5 ${TONE[tone]}`}
		>
			{children}
		</span>
	);
}
